import moment from 'moment-timezone';

export const transformDuration = (duration: string) => {
  // backend always returns a time units - like 'h', 'm', 's'
  // replaced all not DIGITS to ":" and cut last one
  const regexped = (str: string) => str.replace(/\D/g, ':').slice(0, -1);
  return moment.duration(regexped(duration));
};
